import { EmptyStubComponent } from '@components/empty-stub-component'
import { VariationConditionalSelect } from '@components/variation-container/conditional-content'
import { BannerComponent } from '@components/banner-component'
import { ComponentContentTypes } from '../../../lib/types/content-types'
import { ImageAsset } from '../../asset/image'
import { LottieAnimationAsset } from '../../asset/lottie-animation'
import { LottieInteractiveAnimationAsset } from '../../asset/lottie-animation/lottie-interactive-animation-asset'
import { VideoAsset } from '../../asset/video'
import { CtaButton } from '../../item/cta-button'
import { FeatureHighlight } from '../../item/feature-highlight'
import { IconList } from '../../item/icon-list'
import { ItemCtaGroup } from '../../item/cta-group'
import { FaqSection } from '../../section/faq'
import { FormComponent } from '../../form'
import { SectionGroup } from '../../section/group'
import { HeroSection } from '../../section/hero'
import { MultiColumnSection } from '../../section/multi-column'
import { SingleColumnSection } from '../../section/single-column'
import { SectionGoTemplatesTool } from '../../section/go-templates-tool'
import { TestimonialSection } from '../../section/testimonial'
import { TextCheckerSection } from '../../section/text-checker'
import { TrustedBySection } from '../../section/trusted-by'
import { TwoColumnSection } from '../../section/two-column'
import { DynamicSection } from '../../section/dynamic'
import { buildContentRenderer } from '../generic'
import { CitationGeneratorSection } from '../../section/citation-generator'
import { CitationRulesSection } from '../../section/citation-rules'
import { ComponentDynamic } from '../../dynamic'
import { DeviceTypeVariationContainer, AuthAndDeviceTypeCtaVariationContainer } from '../../variation-container'
import { TabsSection } from '../../section/tabs'
import { VerticalTabsSection } from '../../section/vertical-tabs'
import { LinkableBoxesSection } from '../../section/linkable-boxes'
import { IframeComponent } from '../../iframe'
import { TableComponent } from '../../table/table-component'
import { SignUpFormMaskComponent } from '../../sign-up-form-mask'
import { UseCaseSection } from '../../section/use-case'
import { Plans } from '../../plans'
import { PersonalizationVariationContainer } from '../../variation-container/personalization'
import { SocialShareWidget } from '../../share-widget/social-share-widget'
import { PDFAsset } from '@components/asset/pdf'

const contentTypeMap = {
  [ComponentContentTypes.SectionGroup]: SectionGroup,
  [ComponentContentTypes.SectionGrammarCheck]: TextCheckerSection,
  [ComponentContentTypes.SectionCitationGenerator]: CitationGeneratorSection,
  [ComponentContentTypes.SectionCitationRules]: CitationRulesSection,
  [ComponentContentTypes.SectionFaq]: FaqSection,
  [ComponentContentTypes.SectionHero]: HeroSection,
  [ComponentContentTypes.SectionMultiColumn]: MultiColumnSection,
  [ComponentContentTypes.SectionSingleColumn]: SingleColumnSection,
  [ComponentContentTypes.SectionTestimonials]: TestimonialSection,
  [ComponentContentTypes.SectionTrustedBy]: TrustedBySection,
  [ComponentContentTypes.SectionTwoColumns]: TwoColumnSection,
  [ComponentContentTypes.SectionGoTemplatesTool]: SectionGoTemplatesTool,
  [ComponentContentTypes.SectionTabs]: TabsSection,
  [ComponentContentTypes.SectionVerticalTabs]: VerticalTabsSection,
  [ComponentContentTypes.SectionUseCase]: UseCaseSection,
  [ComponentContentTypes.SectionLinkableBoxes]: LinkableBoxesSection,
  [ComponentContentTypes.SectionDynamic]: DynamicSection,
  [ComponentContentTypes.ComponentForm]: FormComponent,
  [ComponentContentTypes.ComponentIframe]: IframeComponent,
  [ComponentContentTypes.ComponentDynamic]: ComponentDynamic,
  [ComponentContentTypes.ComponentCtaButton]: CtaButton,
  [ComponentContentTypes.ComponentTable]: TableComponent,
  [ComponentContentTypes.ComponentSignUpFormMask]: SignUpFormMaskComponent,
  [ComponentContentTypes.ComponentPlansModule]: Plans,
  [ComponentContentTypes.ComponentSocialShareWidget]: SocialShareWidget,
  [ComponentContentTypes.ComponentEmptyStub]: EmptyStubComponent,
  [ComponentContentTypes.ComponentBanner]: BannerComponent,
  [ComponentContentTypes.ItemFeatureHighlight]: FeatureHighlight,
  [ComponentContentTypes.ItemIconList]: IconList,
  [ComponentContentTypes.ItemCtaGroup]: ItemCtaGroup,
  [ComponentContentTypes.AssetImage]: ImageAsset,
  [ComponentContentTypes.AssetLottieAnimation]: LottieAnimationAsset,
  [ComponentContentTypes.AssetLottieInteractiveAnimation]: LottieInteractiveAnimationAsset,
  [ComponentContentTypes.AssetVideo]: VideoAsset,
  [ComponentContentTypes.VariationContainerDeviceType]: DeviceTypeVariationContainer,
  [ComponentContentTypes.VariationContainerAuthAndDeviceTypeCta]: AuthAndDeviceTypeCtaVariationContainer,
  [ComponentContentTypes.VariationContainerPersonalization]: PersonalizationVariationContainer,
  [ComponentContentTypes.VariationContainerConditionalSelect]: VariationConditionalSelect,
  [ComponentContentTypes.AssetPdf]: PDFAsset,
} as const

export const ContentRenderer = buildContentRenderer(contentTypeMap)
